// The free-shipping threshold is not an approved business fact — the $100
// figure came from hardcoded component copy. Until it is confirmed, the cart
// makes no shipping promise. Set this to the approved amount in cents to turn
// the progress bar back on; see FULFILMENT in lib/content/business.ts.
const FREE_SHIPPING_THRESHOLD_CENTS: number | null = null;

export function moneyAmountToCents(amount: string): number {
  return Math.round(Number.parseFloat(amount) * 100);
}

export function centsToDollars(cents: number): number {
  return cents / 100;
}

export function getFreeShippingProgress(amount: string) {
  if (FREE_SHIPPING_THRESHOLD_CENTS === null) return null;

  const subtotalCents = moneyAmountToCents(amount);
  const remainingCents = Math.max(FREE_SHIPPING_THRESHOLD_CENTS - subtotalCents, 0);
  const percent = Math.min(
    Math.floor((subtotalCents * 100) / FREE_SHIPPING_THRESHOLD_CENTS),
    100
  );

  return {
    qualifies: subtotalCents >= FREE_SHIPPING_THRESHOLD_CENTS,
    thresholdCents: FREE_SHIPPING_THRESHOLD_CENTS,
    subtotalCents,
    remainingCents,
    percent,
  };
}

export function isSafeCheckoutUrl(value: string | null | undefined): value is string {
  if (!value) return false;
  try {
    const url = new URL(value);
    return url.protocol === "https:" && url.hostname.length > 0;
  } catch {
    return false;
  }
}

export function getCartCheckoutState({
  isLoading,
  checkoutUrl,
}: {
  isLoading: boolean;
  checkoutUrl: string | null | undefined;
}) {
  if (isLoading) {
    return { disabled: true, label: "Updating cart..." };
  }

  if (!isSafeCheckoutUrl(checkoutUrl)) {
    return { disabled: true, label: "Checkout unavailable" };
  }

  return { disabled: false, label: "Checkout" };
}
